module.exports = __webpack_public_path__ + "img/179988.389bd285.png";